import React from "react";
import { Seo } from "../components/Seo";
import { PageHeader } from "../components/PageHeader";

export default function LegalPage({ title, content }) {
  return (
    <div data-testid={`legal-${title.toLowerCase().replace(/\s+/g, '-')}`}>
      <Seo title={`${title} — IDEAL ENTERPRISES`} description={`${title} for IDEAL ENTERPRISES.`} />
      <PageHeader overline="LEGAL" title={title} />
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-6 lg:px-10 space-y-5 text-slate-700 leading-relaxed">
          {content.map((p, i) => (<p key={i}>{p}</p>))}
        </div>
      </section>
    </div>
  );
}
